import {SkuFoodCategoryCountType} from "../../../../common/types";
import ReactApexChart from "react-apexcharts";
import {Card} from "antd";
import React from "react";

// Тип пропсов для компонента: ожидает массив данных по категориям
type Top10CategoryFoodPieChartPropsType = {
    data: SkuFoodCategoryCountType[]
}

export const Top10CategoryFoodPieChart = ({data}: Top10CategoryFoodPieChartPropsType) => {

    // Массив для названий категорий
    const categories: string[] = []
    // Массив для значений (количество позиций)
    const series: number[] = []

    // Сортировка данных по количеству позиций, выбор топ-10
    const sortData = [...data].sort((a,b) => b.quantity_positions - a.quantity_positions).slice(0,10)

    // Заполнение массивов для графика
    sortData.forEach((el) => (categories.push(el.name_category), series.push((el.quantity_positions))))

    // Опции для ApexCharts: настройки графика, заголовка, легенды, адаптивности
    const options = {
        chart: {
            width: 380,
            type: 'pie' as const,
        },
        labels: categories,
        title: {
            text: 'Топ 10 категорий, %',
            align: 'center' as const,
            margin: 20,
            style: {

                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        legend: {
            labels: {
                colors: '#FFFFFF'
            },
            position: 'bottom' as const
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    }

    // Отрисовка карточки с круговой диаграммой
    return (
        <Card style={{
            backgroundColor: '#293133',
            borderRadius: 20,
            paddingLeft: 20,
            paddingRight: 20,
            width: '50%'
        }}>
            {/* Круговая диаграмма ApexCharts */}
            <ReactApexChart
                options={options}
                series={series}
                type={'pie'}
                height={500}
                style={{color: '#FFFFFF'}}
            />
        </Card>
    );
};
